import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import compose from 'recompose/compose';
import Header from 'components/ui/general/Header';
import listQueryFilter from 'components/hoc/listQueryFilter';
import ReservationCSVExport from './actions/csv/ReservationCSVExport';
import ReservationsList from './ReservationsList';
import ReservationsListFilters from './ReservationsListFilters';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';

const ReservationsListContainer = (props) => {
    const {
        actionType,
        filter,
        location,
        resource,
        total,
        translate,
        updateQuery,
    } = props;

    return (
        <div>
            <Header>
                <Title title={ translate('resources.reservations.title') } />

                <Actions>
                    <ReservationCSVExport
                        base='created_at'
                        label={ translate('resources.orders.actions.csv') }
                        filterValues={ filter }
                        total={ total }
                    />
                </Actions>
            </Header>

            <ReservationsListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ReservationsList
                { ...props }
            />
        </div>
    );
};

ReservationsListContainer.propTypes = {
    actionType: PropTypes.string.isRequired,
    filter: PropTypes.object,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    total: PropTypes.number,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {
        filter: state.reservations.filter,
        total: state.reservations.total,
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    listQueryFilter,
);

export default enhance(ReservationsListContainer);



// WEBPACK FOOTER //
// ./src/pages/reservations/list/ReservationsListContainer.js